import moment from "moment";
import React, { useEffect, useState } from "react";
import { API, fileUpload } from "../../../../config";
import Spin from "../../../../components/Spin";
import { Label } from "../../../../components/ui/label";
import CustomLabelText from "../../../../components/CustomLabelText";
import { DateInputPicker } from "../../../../components/DateInputPicker";
import UserSelect from "../../../../components/UserSelect";
import { Loader2 } from "lucide-react";
import { Button } from "../../../../components/ui/button";
import { useOrganization } from "../../../../lib/context/OrganisationContext";
import { formatSubcontractorName } from "../../../../lib/Misc";

const PolicyApproveModal = ({
  id,
  fetchPolicies,
  nextModal,
  setNextModal,
  toggleApproveModal,
  setReviewDate,
  setComplianceManagerId,
  reviewDate,
  complianceManagerId,
}) => {
  const [userLoading, setUserLoading] = useState(false);
  const { organizationData } = useOrganization();
  const [userListing, setUserListing] = useState([]);
  const [userList, setUserList] = useState([]);

  const [loading, setLoading] = useState(false);

  const handleApprove = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append(
        `next_review_date`,
        reviewDate ? moment(reviewDate)?.format("DD-MM-YYYY") : null
      );
      formData.append(
        `compliance_manager_id`,
        complianceManagerId ? complianceManagerId : ""
      );
      formData.append("approved", 1);
      formData.append("_method", "put");
      await fileUpload(`${API.GET_POLICIES}/${id}`, formData);
      setLoading(false);
      toggleApproveModal();
      fetchPolicies();
      setNextModal(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userList) {
      let userTempListing = userList?.map((item) => ({
        ...item,
        value: item?.id,
        label: formatSubcontractorName(item),
      }));
      setUserListing(userTempListing || []);
    } else {
      setUserListing([]);
    }
  }, [userList]);

  return (
    <div className="relative">
      {loading && <Spin expand={true} smallModal={true} fullscreen={true} />}
      <div className={nextModal ? "text-center" : ""}>
        {nextModal ? (
          "Are you sure you want to approve this policy?"
        ) : (
          <>
            <div className="grid gap-2">
              <Label htmlFor="file_note">
                <CustomLabelText required={true} labelText="Next Review Date" />
              </Label>
              <DateInputPicker
                date={reviewDate}
                onSelect={(e) => {
                  setReviewDate(e);
                }}
                className={"w-[200px] text-left"}
                inputClassName="w-full"
                icon={true}
              />
            </div>
            <div className="grid gap-2 mt-3">
              <div className="min-w-0">
                <Label htmlFor="compliance_manager_id">
                  <CustomLabelText
                    required={true}
                    labelText="Compliance Officer"
                  />
                </Label>
                <div className="relative mt-2">
                  <UserSelect
                    orgId={organizationData?.organizationId}
                    frameworkData={userListing} // List of vendors
                    optionType="User"
                    handleSelect={(e) => {
                      setComplianceManagerId(e);
                    }}
                    name="compliance_manager_id"
                    disabled={false}
                    initialValue={
                      complianceManagerId ? complianceManagerId : ""
                    }
                    setUserList={setUserList}
                    setUserLoading={setUserLoading}
                    onClear={() => {
                      setComplianceManagerId("");
                    }}
                    compliance={true}
                    loading={userLoading}
                  />
                  {userLoading && (
                    <span className="absolute top-2 right-2 animate-spin">
                      <Loader2 width={20} height={20} />
                    </span>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
        <Button
          type="submit"
          onClick={(e) => {
            e.preventDefault();
            nextModal ? handleApprove(1) : setNextModal(true);
          }}
          disabled={nextModal ?  false : !complianceManagerId}
        >
          {nextModal ? "Post" : "Next"}
        </Button>
        <Button
          className="reset ml-3"
          data-dismiss="modal"
          aria-label="Close"
          variant="secondary"
          onClick={(e) => {
            e.preventDefault();
            setNextModal();
            toggleApproveModal();
          }}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default PolicyApproveModal;
